import { render, staticRenderFns } from "./mafiaways2.vue?vue&type=template&id=38013c74"
import script from "./mafiaways2.vue?vue&type=script&lang=js"
export * from "./mafiaways2.vue?vue&type=script&lang=js"
import style0 from "./mafiaways2.vue?vue&type=style&index=0&id=38013c74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports